/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Input_PlaceholderInputs */

const en_rd_input_placeholder = /** @type {(inputs: Rd_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://github.com/owner/repo`)
};

const id_rd_input_placeholder = /** @type {(inputs: Rd_Input_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://github.com/pemilik/repo`)
};

/**
* | output |
* | --- |
* | "https://github.com/owner/repo" |
*
* @param {Rd_Input_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_input_placeholder = /** @type {((inputs?: Rd_Input_PlaceholderInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Input_PlaceholderInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_input_placeholder(inputs)
	return en_rd_input_placeholder(inputs)
});